import { render } from "./BuyCreditsDialog.vue?vue&type=template&id=c1f5932a&scoped=true"
import script from "./BuyCreditsDialog.vue?vue&type=script&lang=ts"
export * from "./BuyCreditsDialog.vue?vue&type=script&lang=ts"

import "./BuyCreditsDialog.vue?vue&type=style&index=0&id=c1f5932a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c1f5932a"

export default script